import { render, staticRenderFns } from "./MachineryManufactur.vue?vue&type=template&id=3e94ac4b&scoped=true"
import script from "./MachineryManufactur.vue?vue&type=script&lang=js"
export * from "./MachineryManufactur.vue?vue&type=script&lang=js"
import style0 from "./MachineryManufactur.vue?vue&type=style&index=0&id=3e94ac4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e94ac4b",
  null
  
)

export default component.exports